// This file manages exports from the base atom, molecule, or organism.
// Use named rather than default exports.
import dynamic from 'next/dynamic';
import { EditableComponent } from '@adobe/aem-react-editable-components';

const WebPromptMobile = dynamic(() => import('./WebPromptMobile').then(mod => mod.WebPromptMobile));

export const WebPromptMobileConfig = {
  emptyLabel: 'addmobilephone',
  isEmpty: false,
  resourceType: `mi-aem-account/components/content/addmobilephone`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const WebPromptMobileEditable = (props: any) => (
  <EditableComponent config={WebPromptMobileConfig} {...props}>
    <WebPromptMobile {...props} />
  </EditableComponent>
);
